import { useRouteError } from 'react-router-dom';

import { AppErrorBoundary } from './AppErrorBoundary.component';

export const RouterErrorElement = () => {
  const routeError = useRouteError();

  return <AppErrorBoundary error={routeError} />;
};
